import wx from 'weixin-js-sdk'

export const commonShare = (_this, shareTitle, shareUrl, shareImg, shareDesc) => {

  _this.$http({
    url: 'live/share/shareConfig',
    method: 'get',
    params:{
      'url':shareUrl.split('#')[0]
    }
  }).then(({ data }) => {
    let newData = data
    if (newData && newData.code === 0) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: newData.data.appId, // 必填，公众号的唯一标识
        timestamp: newData.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: newData.data.nonceStr, // 必填，生成签名的随机串
        signature: newData.data.signature, // 必填，签名，见附录1
        jsApiList: ['onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function () {
        const obj = {
          title: shareTitle, // 分享标题
          desc: shareDesc, // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareImg, // 分享图标
          type: "", // 分享类型,music、video或link，不填默认为link
          dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
          fail: function (res) {
            alert(JSON.stringify(res));
          }
        }
        // 2.1 监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareAppMessage(obj);

        // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareTimeline(obj);

        // 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareQQ(obj);

        // 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareWeibo(obj);

        // 2.5 监听“分享到QZone”按钮点击、自定义分享内容及分享接口
        wx.onMenuShareQZone(obj);
      });
    }
  })

};
export const shareIndex = (_this, shareTitle, shareUrl, shareImg, shareDesc) => {

  _this.$http({
    url: 'live/share/shareConfig',
    method: 'get',
    params:{
      'url':shareUrl.split('#')[0]
    }
  }).then(({ data }) => {
    let newData = data
    if (newData && newData.code === 0) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: newData.data.appId, // 必填，公众号的唯一标识
        timestamp: newData.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: newData.data.nonceStr, // 必填，生成签名的随机串
        signature: newData.data.signature, // 必填，签名，见附录1
        jsApiList: ['onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function () {
        const obj = {
          title: shareTitle, // 分享标题
          desc: shareDesc, // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareImg, // 分享图标
          type: "", // 分享类型,music、video或link，不填默认为link
          dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
          fail: function (res) {
            alert(JSON.stringify(res));
          }
        }
        // 2.1 监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareAppMessage(obj);

        // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareTimeline(obj);

        // 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareQQ(obj);

        // 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareWeibo(obj);

        // 2.5 监听“分享到QZone”按钮点击、自定义分享内容及分享接口
        wx.onMenuShareQZone(obj);
      });
    }
  })

};
export const videoShare = (_this, shareTitle, shareUrl, shareImg, shareDesc) => {

  _this.$http({
    url: 'live/share/shareConfig',
    method: 'get',
    params:{
      'url':shareUrl.split('#')[0]
    }
  }).then(({ data }) => {
    let newData = data
    if (newData && newData.code === 0) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: newData.data.appId, // 必填，公众号的唯一标识
        timestamp: newData.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: newData.data.nonceStr, // 必填，生成签名的随机串
        signature: newData.data.signature, // 必填，签名，见附录1
        jsApiList: ['onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function () {
        const obj = {
          title: shareTitle, // 分享标题
          desc: shareDesc, // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareImg, // 分享图标
          type: "", // 分享类型,music、video或link，不填默认为link
          dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
          fail: function (res) {
            alert(JSON.stringify(res));
          }
        }
        // 2.1 监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareAppMessage(obj);

        // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareTimeline(obj);

        // 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareQQ(obj);

        // 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareWeibo(obj);

        // 2.5 监听“分享到QZone”按钮点击、自定义分享内容及分享接口
        wx.onMenuShareQZone(obj);
      });
    }
  })

};
